import React, { PureComponent } from 'react';
import './Header.css';
import * as _ from 'lodash';

class Header extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {visible: true};

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', _.throttle(this.handleScroll, 250));
    }

    handleScroll() {

        if (this.state.visible) {
            const headerHeight = 63;

            if (window.scrollY > headerHeight) {
                this.setVisible(false);
            }
        }
    }

    setVisible(vis) {
        if (vis) {
            this.scrollDownAtTopAttempts = 0;
        }

        this.setState({visible: vis});
    }

    render() {

        const styles = this.state.visible ? {} : {display: "none"};

        return (
            <div className="uk-container uk-margin-bottom" style={styles}>
                <div className="title-container">
                    <Logo />
                    <span className="title">Client Health Scorecard</span>
                </div>
                <div>
                    <span>Need help? Check out the </span>
                    <a href="https://curalate.atlassian.net/wiki/spaces/PM/pages/140509220/Client+Heath+Initiative+Launch" target="_blank" rel="noopener noreferrer">documentation</a>
                    <span> or find answers/report problems in the </span>
                    <a href="slack://channel?team=T029TKV1Q&amp;id=C6UUDUJ5Q">#client-health-sc</a>
                    <span> slack channel. Check out the </span>
                    <a href={`${process.env.PUBLIC_URL}/release_notes.html`} target="_blank" rel="noopener noreferrer">release notes</a>
                    <span> to see recent changes.</span>
                </div>
            </div>
        );
    }
}

class Logo extends PureComponent {

    render() {
        return (
            <svg className="logo" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style={{enableBackground: "new 0 0 64 64"}} xmlSpace="preserve">
                <g>
                    <polygon className="st0" points="42.7,21.4 64.1,21.4 64.1,0 	"/>
                    <polygon className="st1" points="21.4,42.7 0,64.1 21.4,64.1 42.7,64.1 42.7,42.7 	"/>
                    <polygon className="st2" points="64.1,42.7 42.7,42.7 42.7,64.1 	"/>
                    <polygon className="st3" points="21.4,42.7 21.4,42.7 21.4,42.7 21.4,21.4 0,21.4 0,42.7 0,42.7 0,64 21.3,42.7 21.4,42.7 	"/>
                    <rect x="21.4" y="21.4" className="st4" width="21.4" height="21.4"/>
                    <polygon className="st5" points="21.4,21.4 42.7,21.4 64.1,0 42.7,0 42.7,0 21.4,0 	"/>
                    <polygon className="st6" points="0,21.4 21.4,21.4 21.4,0 	"/>

                </g>
            </svg>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Header.js